import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod/v4';

import { Button, TextInput } from '@engecomp/shared/components';
import { UserRepo } from '@engecomp/shared/repositories';
import { RPrefix } from '@engecomp/shared/utils';

import LogoIcon from '@engecomp/shared/icons/logo.svg';

import styles from './index.module.css';

const schema = z.object({
  email: z.string().min(1, { message: 'obrigatório' }),
});

type Schema = z.infer<typeof schema>;

export function ForgotPassword() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Schema>({ resolver: zodResolver(schema) });

  const onSubmit = async (data: Schema) => {
    try {
      await UserRepo.sendRecoverPasswordEmail({ email: data.email });
      toast.success('Código enviado por e-mail com sucesso!');
      navigate(`${RPrefix.auth}/recuperar-senha`);
    } catch (error: any) {
      toast.error('Erro ao enviar e-mail de recuperação');
      console.error('Erro ao enviar recuperação de senha:', error);
    }
  };

  return (
    <>
      <header className={styles.ForgotPassword_Header}>
        <img src={LogoIcon} />
      </header>

      <section className={styles.ForgotPassword_Title}>
        <p>Esqueceu a senha?</p>
      </section>

      <section className={styles.ForgotPassword_SubTitle}>
        <p>
          Digite seu endereço de e-mail e enviaremos um
          <br />
          link para redefinir sua senha.
        </p>
      </section>

      <div className={styles.ForgotPassword_box}>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.ForgotPassword_Form}>
          <div className={styles.fieldsForm}>
            <TextInput
              style={{ overflow: 'hidden' }}
              label='E-mail:'
              placeholder='E-mail'
              field='email'
              type='email'
              errors={errors}
              {...{ register }}
            />
          </div>
          <Button className={styles.button}>Enviar recuperação pelo e-mail</Button>
        </form>
      </div>

      <a onClick={() => navigate(`${RPrefix.auth}/login`)} className={styles.ForgotPassword_Link}>
        Voltar
      </a>

      <a className={styles.ForgotPassword_Link} href={`${RPrefix.auth}/recuperar-senha`}>
        Ativar conta
      </a>
    </>
  );
}
